import * as t from './actionTypes';
import { errorText } from '../../../shared/lib/reducer-util';

const initialState = {
  loading: false,
  loaded: false,
  ratings: null,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case t.LOAD_OTP_BY_FLIGHT:
      return {
        ...state,
        error: null,
      };
    case t.LOAD_OTP_SUCCESS:
      return {
        ...state,
        error: null,
        loaded: true,
        ratings: action.result,
      };
    case t.LOAD_FAIL:
      return {
        ...state,
        loaded: false,
        error: errorText(action.error),
      };
    case t.START_SPINNER:
      return {
        ...state,
        loading: true,
      };
    case t.END_SPINNER:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./modules/OnTimePerformance/redux/reducer.js